import { render, staticRenderFns } from "./UpDownCustomer.vue?vue&type=template&id=7c2299e9&scoped=true&"
import script from "./UpDownCustomer.vue?vue&type=script&lang=js&"
export * from "./UpDownCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2299e9",
  null
  
)

export default component.exports